document.addEventListener("turbo:load", () => {
  initPromotionalPopups();
});

document.addEventListener("turbo:render", () => {
  initPromotionalPopups();
});

document.addEventListener('turbo:frame-render', function (event) {
  if (event.target.id === 'pdf-viewer') {
    initPromotionalPopups();
  }
});

function initPromotionalPopups() {
  const pdfContainer = document.getElementById('pdf-viewer-container');

  if (!pdfContainer) return;

  const variantId = pdfContainer.dataset.variantId;
  let currentPage = parseInt(pdfContainer.dataset.currentPage);

  let popupChecked = false;

  function checkForPopup(page) {
    if (popupChecked) return;

    popupChecked = true;

    fetch(`/promotional_popups/show?variant_id=${variantId}&page_number=${page}`)
      .then(response => response.json())
      .then(data => {
        if (data.popup_found) {
          document.getElementById('popup-title').textContent = data.title;
          document.getElementById('popup-subtitle').textContent = data.subtitle;

          if (data.image_path) {
            const popupImage = document.getElementById('popup-image');
            popupImage.src = data.image_path;
            document.getElementById('popup-image-container').style.display = 'block';
          } else {
            document.getElementById('popup-image-container').style.display = 'none';
          }

          const popupButton = document.getElementById('popup-button');
          popupButton.textContent = data.button_text;
          popupButton.href = data.button_url;

          // Store popup ID for tracking
          popupButton.dataset.popupId = data.popup_id;

          // Prevent the modal from closing automatically when clicking the button
          popupButton.setAttribute('data-bs-dismiss', '');
          popupButton.onclick = function (e) {
            e.preventDefault();

            // Track popup button click
            trackPopupInteraction(data.popup_id, 'clicked');

            window.location.href = data.button_url;
          };

          // Track popup dismissal
          const modal = document.getElementById('promotional-popup-container');
          modal.addEventListener('hidden.bs.modal', function () {
            trackPopupInteraction(data.popup_id, 'dismissed');
          }, { once: true });

          $('#promotional-popup-container').modal('show');
        }
      })
      .catch(error => {
        console.error('Error checking for promotional popup:', error);
      });
  }

  function trackPopupInteraction(popupId, actionType) {
    if (!popupId) return;

    fetch('/promotional_popups', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({
        popup_id: popupId,
        action_type: actionType
      })
    }).catch(error => {
      console.error('Error tracking popup interaction:', error);
    });
  }

  checkForPopup(currentPage);

  document.addEventListener('page:changed', function (e) {
    if (e.detail && e.detail.pageNumber) {
      // Reset popup check state for the new page
      popupChecked = false;
      checkForPopup(e.detail.pageNumber);
    }
  });

  const prevButton = document.querySelector('.page-navigation .prev-page');
  const nextButton = document.querySelector('.page-navigation .next-page');

  if (prevButton && nextButton) {
    prevButton.addEventListener('click', function () {
      // Wait a bit for the page to change before checking
      setTimeout(() => {
        const updatedPage = parseInt(pdfContainer.dataset.currentPage);

        popupChecked = false;
        checkForPopup(updatedPage);
      }, 500);
    });

    nextButton.addEventListener('click', function () {
      setTimeout(() => {
        const updatedPage = parseInt(pdfContainer.dataset.currentPage);

        popupChecked = false;
        checkForPopup(updatedPage);
      }, 500);
    });
  }
}
